import React, { useState, useEffect } from 'react';
import request from '../../../../../logic/utils/request';
import { Title, PreloaderBox } from '../../../../../common/ui/Common';
import WorkPlacesTable from './WorkPlacesTable';
import { useToggle } from '../../../../../logic/hooks/useToggle';
import NewWorkPlace from './NewWorkPlace/NewWorkPlace';
import fetchZoneList from './fetchZoneList';

function WorkPlaces({ preloader, showError, write }) {
  const initialData = {
    connectedQueues: [],
    connectedZones: [],
    description: '',
    dictionary: { filtersA: [] },
    disabled: false,
    mobile_wplace: false,
    name: '',
    placename: '',
    soundtext: '',
  };
  const [placeList, setPlaceList] = useState(null);
  const [placeData, setPlaceData] = useState(initialData);
  const [placeUpdate, setPlaceUpdate] = useState(false);
  const [zones, setZones] = useState([]);
  const [defaultParams, setDefaultParams] = useState([]);
  const [queues, setQueues] = useState([]);
  const [isOpen, toggleOpen] = useToggle(false);

  const fetchPlaces = async () => {
    const res = await request('/server/api/wplace/', 'get');
    setPlaceList(res.data.data);
  };

  const fetchData = async () => {
    const [zoneList, placesListReq, officeParamsReq, queueListReq] = await Promise.all([
      fetchZoneList(),
      request('/server/api/wplace/', 'get'),
      request('/server/api/officeparams/', 'get'),
      request('/server/api/queue/', 'get'),
    ]);
    setZones(zoneList);
    setDefaultParams(officeParamsReq.data.data.filter((el) => (el.applicability || '').includes('wplace')));
    setQueues([...queueListReq.data.data]);
    setPlaceList(placesListReq.data.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Title>Рабочие места</Title>
      <NewWorkPlace
        initialData={initialData}
        preloader={preloader}
        toggleOpen={toggleOpen}
        isOpen={isOpen}
        fetchPlaces={fetchPlaces}
        placeData={placeData}
        setPlaceData={setPlaceData}
        setPlaceUpdate={setPlaceUpdate}
        placeUpdate={placeUpdate}
        zones={zones}
        queues={queues}
        showError={showError}
      />
      <PreloaderBox>
        <WorkPlacesTable
          placeList={placeList}
          fetchPlaces={fetchPlaces}
          preloader={preloader}
          setPlaceUpdate={setPlaceUpdate}
          setPlaceData={setPlaceData}
          toggleOpen={toggleOpen}
          write={write}
          zones={zones}
          defaultParams={defaultParams}
          queues={queues}
          showError={showError}
        />
      </PreloaderBox>
    </>
  );
}
export default WorkPlaces;
